import { useNavigate } from 'react-router-dom'

const MODES = [
  { value: 'organizer', label: 'Организатор' },
  { value: 'participant', label: 'Участник' },
  { value: 'guk', label: 'ГУК' }
]

const Main = () => {
  const navigate = useNavigate()

  return (
    <div className="flex w-full flex-col items-stretch justify-center gap-[1.25rem] sm:flex-row sm:flex-wrap">
      {MODES.map(({ value, label }) => (
        <button
          key={value}
          type="button"
          onClick={() => navigate(`/auth/${value}`)}
          className="flex h-[8rem] w-full cursor-pointer items-center justify-center rounded-[20px] border border-solid border-[#d9d9d9] bg-white px-[1.5rem] text-center text-[1.25rem] font-medium text-[#202020] transition-colors hover:border-[#0d9488] hover:bg-[#0d9488] hover:text-white sm:h-[12rem] sm:w-[18rem] sm:text-[1.5rem] lg:h-[17.5rem] lg:w-[28.75rem] lg:text-[1.75rem]"
        >
          {label}
        </button>
      ))}
    </div>
  )
}

export default Main
